// modules/BackButton.js
import React            from 'react';
import { Link }         from 'react-router';
// import { browserHistory } from 'react-router';

class BackButton extends React.Component {
	render() {
		return (
			<Link to={this.props.link}>
				<div className="w-10-md fl w-100 cursor-hover">
					<p className="m-b-0 p-h-1 smaller-blue-font tl">&lt; Go Back</p>
				</div>
			</Link>
		);
	}
}

export default BackButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/BackButton.js
 **/